import { render, staticRenderFns } from "./EntityItemEmpty.vue?vue&type=template&id=50ed2d4b&"
import script from "./EntityItemEmpty.vue?vue&type=script&lang=ts&"
export * from "./EntityItemEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports